// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"r_-z","narrowOptionButtons":"s_-z","noOptions":"t_-z"};